import React from "react";

interface Props {
  children: React.ReactNode;
}

export default function Hint({ children }: Props) {
  return (
    <div className="text-base text-slate-600 font-normal">
      {children}
    </div>
  );
}
